const BACKEND = process.env.REACT_APP_BACKEND_URL;

/** Resolve a possibly-relative image URL stored in DB to a full URL.
 * Returns undefined for falsy input so <img src={undefined}> isn't rendered. */
export const resolveImg = (p) => {
    if (!p) return undefined;
    if (p.startsWith("http")) return p;
    return `${BACKEND}${p}`;
};
